@use '@design/design-tokens/typography/typography' as *;

.label {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: 16px;
  @include typography-v2-body-xs;
  color: var(--text-soft);
}
